import { OAuthStorage } from 'angular-oauth2-oidc';
import { Injectable } from '@angular/core';

export const OAUTH_STORAGE_SCOPE = 'apiSubs';

@Injectable()
export class OAuthScopedStorage implements OAuthStorage {

    private scope_: string;

    constructor() {
        this.scope_ = OAUTH_STORAGE_SCOPE;
    }

    setItem(key: string, data: string) {
        sessionStorage.setItem(this.getScopedKey_(key), data);
    }

    getItem(key: string) {
        return sessionStorage.getItem(this.getScopedKey_(key));
    }

    removeItem(key: string) {
        sessionStorage.removeItem(this.getScopedKey_(key));
    }

    private getScopedKey_(key: string) {
        return `${this.scope_}.${key}`;
    }
}



// WEBPACK FOOTER //
// ./src/main/services/user/oauth-scoped-storage.ts